import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.search";
import _typeof from "E:/wnmp/www/www.yunkezan.com/vuecli3/node_modules/@babel/runtime/helpers/esm/typeof.js";
/* eslint-disable */
/*产品分享弹框组件
 * <component-product-promotion type="1" :password="password" :poster-link="posterLink" :poster="img"  :share-txt="" :share-link=""></component-product-promotion>
 * type:1.产品详情页  2.酒景门店详情页
 * password:商品口令加密串，必传
 * posterLink:生成海报图所需的链接，商详页传
 * poster:海报图链接地址，酒景页传
 * share-txt:短链接分享文案
 * share-link:短链接分享链接
 */
import { buryingPoint } from "@/util/buryingPoint";
import ComponentNobrandQrcode from "./nobrand_qrcode.vue";
import { updateUrlParam, toast as _toast, showLoading as _showLoading, hideLoading } from "@ykz/ykz-util/base";
import { isIos, isYkzMiniprogram, isYkzAlipayMiniprogram, copy, checkCopyUsable, goDownload } from "@ykz/ykz-util/platform";
import databus, { Origins } from "@ykz/ykz-http/core";
export default {
  name: "productPromotion",
  components: {
    ComponentNobrandQrcode: ComponentNobrandQrcode
  },
  data: function data() {
    return {
      loadProductPromotion: false,
      //渲染产品分享弹框
      showProductPromotion: false,
      //显示产品分享弹框
      productPromotionSlideDown: true,
      //产品分享弹框是否滑下，默认true
      showPasswordCopy: false,
      //口令复制弹框
      passwordCopyStatus: 0,
      //口令复制弹框的状态  1.生成中 2.长按复制 3.复制成功
      showShareLink: false,
      //分享链接弹框
      shareLinkBoxStatus: 0,
      //分享链接弹框的状态  1.生成中 2.长按复制 3.点击复制 4.点击再次复制
      showForwardWechat: false,
      //小程序转发微信引导图
      showOutAnimation: false,
      //展示关闭弹框动画

      goodId: getUrlParams("goodId") || "",
      //商品id
      scenicId: getUrlParams("scenicId") || getUrlParams("storeId") || 1,
      //酒景门店id
      isAPP: window.mobileEnv == "app" ? true : false,
      //是否在云客赞app打开页面
      isMini: isYkzMiniprogram(),
      //是否在微信小程序打开页面
      isAlipayMini: isYkzAlipayMiniprogram(),
      // 是否在支付宝小程序内
      isIos: isIos(),
      //是否在ios机
      isPoint: false,
      //是否需要显示引导指示，针对注册后首次进入商城的推广员
      _this: {},
      //产品详情页的this对象
      shortUrl: "",
      //短链接
      posterImg: "",
      //海报
      posterNoImg: "" //无品牌海报
    };
  },

  props: {
    type: {
      //1.产品详情页  2.酒景详情页
      type: null,
      default: 1
    },
    password: {},
    //商品口令加密串
    posterLink: {},
    //生成海报图所需的链接，商详页传
    poster: {},
    //海报，用于判断酒景页是否显示生成海报按钮
    shareTxt: {},
    //短链接分享文案
    shareLink: {},
    //短链接分享链接
    isOpenShop: {},
    //是否是店长
    showVideo: {},
    // 是否显示视频号
    kv: {},
    shareReward: false
  },
  mounted: function mounted() {
    _typeof(window.componentCenter) == "object" || (window.componentCenter = {});
    window.componentCenter.productPromotion = this;
    console.log("ycf组件初始化：productPromotion");
  },
  methods: {
    // 接入talkingdata进行埋点统计
    // 微信好友
    handleShareForwardWechat: function handleShareForwardWechat() {
      buryingPoint("SXY-DJWXHY", "点击微信好友", this.kv);
      YCF_Plugin.anchorPoint("商品分享_微信好友", "gooddetail_share_friend", "goodsId:".concat(this.goodsId));
      this.showForwardWechat = true;
    },
    // 生成APP海报
    handleCreateAppPoster: function handleCreateAppPoster() {
      buryingPoint("SXY-DJSCAPPHB", "点击生成APP海报", this.kv);
      this.copyPassword();
    },
    // 生成海报
    handleCreatePoster: function handleCreatePoster(_this) {
      buryingPoint("SXY-DJSCHB", "点击生成海报", this.kv);
      YCF_Plugin.anchorPoint("商品分享_分享海报", "gooddetail_share_poster", "goodsId:".concat(this.goodsId));
      this.getPoster(_this);
    },
    // 无品牌海报
    handleCreateNoPoster: function handleCreateNoPoster(_this) {
      this.getNoPoster(_this);
    },
    // 短链接
    handleCreateShareLink: function handleCreateShareLink() {
      buryingPoint("SXY-DJDLJ", "点击短链接", this.kv);
      YCF_Plugin.anchorPoint("商品分享_分享链接", "gooddetail_share_link", "goodsId:".concat(this.goodsId));
      this.getShortUrl();
    },
    handleShareVideo: function handleShareVideo() {
      this.$emit("videosale");
      this.showProductPromotion = false;
    },
    //显示产品分享或分享弹框
    showShare: function showShare(_this, str) {
      str == "showProductMask" && sessionStorage.removeItem("showProductMask"); //只执行一次引导分享
      if (this.isAPP) {
        if (str == "showProductMask") {
          ykzApp.ready(function () {
            ykzApp.showLinkShare && ykzApp.showLinkShare();
          });
        } else {
          this.getPoster(_this);
          this.getNoPoster(_this);
        }
      } else {
        if (this.loadProductPromotion) {
          this.slideUpProductPromotion(_this, str);
        } else {
          this.loadProductPromotion = true;
          this.$nextTick(function () {
            this.slideUpProductPromotion(_this, str);
          });
        }
      }
    },
    //隐藏口令复制或分享链接弹框  type：1.口令复制弹框  2.分享链接弹框
    hideBox: function hideBox(type) {
      var that = this,
        timer = null;
      this.showOutAnimation = true;
      timer = setTimeout(function () {
        clearTimeout(timer);
        that.showOutAnimation = false;
        type == 1 && (that.showPasswordCopy = false);
        type == 2 && (that.showShareLink = false);
      }, 200);
    },
    //toast
    toast: function toast(str) {
      _toast(str);
    },
    //Loading
    showLoading: function showLoading(toastText) {
      _showLoading({
        cover: true,
        opacity: 0,
        toastText: toastText
      });
    },
    //大数据锚点
    reportUserAnchors: function reportUserAnchors(event_id, callback) {
      YCF_Plugin.reportUserAnchors({
        event_id: event_id,
        event_content: {
          item_id: this.type == 1 ? this.goodId : this.scenicId
        },
        page_name: this.type == 1 ? "产品详情页" : location.href.search("/front/platform/goodsDetails") != -1 ? "酒景详情页" : "门店详情页"
      }).always(callback);
    },
    //设置hash值
    setHash: function setHash(str) {
      if (location.hash.replace("#", "") != str) {
        location.hash = str;
      }
    },
    //向上滑动显示产品分享弹框
    slideUpProductPromotion: function slideUpProductPromotion(_this, str) {
      this._this != _this && (this._this = _this || {});
      var that = this;
      that.showProductPromotion = true;
      setTimeout(function () {
        that.productPromotionSlideDown = false;
        that.setHash(that.type == 1 ? "productPromotion" : "scenicPromotion");
        str == "showProductMask" && setTimeout(function () {
          that.showShareLink = true;
        }, 250);
        str == "isPoint" && (that.isPoint = true);
      }, 30);
    },
    //向下滑动隐藏产品分享弹框
    slideDownProductPromotion: function slideDownProductPromotion(callback) {
      var that = this;
      that.productPromotionSlideDown = true;
      setTimeout(function () {
        that.showProductPromotion = false;
        (that.type == 1 ? location.hash == "#productPromotion" : location.hash == "#scenicPromotion") && history.go(-1);
        typeof callback == "function" && callback();
      }, 300);
    },
    //跳转到app下载页
    goDownloadPage: function goDownloadPage() {
      var that = this;
      if (this.type == 1) {
        YCF_Plugin.reportUserAnchors({
          event_id: "500173"
        }).always(function () {
          !that.isIos && goDownload("STbGby");
        });
      } else {
        !that.isIos && goDownload("STbGby");
      }
    },
    //复制口令
    copyPassword: function copyPassword() {
      if (this.passwordCopyStatus > 1) {
        this.showPasswordCopy = true;
        return true;
      }
      var that = this;
      this.showPasswordCopy = true;
      if (this.isIos) {
        this.passwordCopyStatus = 3;
        this.$nextTick(function () {
          $(".password-copy .transition-content").css("height", $(".password-copy .status-two").innerHeight());
          YCF_Plugin.linkedmeInit({
            btnQueue: {
              $elem: $(".password-copy .btn-goPage"),
              link: location.href
            }
          });
        });
        return true;
      }
      if (!this.password) {
        this.passwordCopyStatus = 1;
        $(".password-copy .transition-content").css("height", $(".password-copy .status-one").innerHeight());
        if (that.password) {
          checkVersion();
        } else {
          that.hideBox(1);
          that.toast("口令生成失败，请刷新页面重试！");
        }
      } else {
        checkVersion();
      }

      //判断用户设备是否可复制口令，显示对应的弹框样式
      function checkVersion() {
        if (checkCopyUsable(10)) {
          copy(that.password).success(function () {
            that.passwordCopyStatus = 3;
            that.$nextTick(function () {
              $(".password-copy .transition-content").css("height", $(".password-copy .status-two").innerHeight());
            });
          }).fail(function () {
            that.hideBox(1);
            that.toast("口令复制失败，请重试！");
          });
        } else {
          that.passwordCopyStatus = 2;
          that.$nextTick(function () {
            $(".password-copy .transition-content").css("height", $(".password-copy .status-two").innerHeight());
          });
        }
        $(".password-copy .status-two .txt-p").bind("touchstart", function () {
          that.selectText(this);
        });
      }
    },
    //复制无品牌链接
    copyNoBrandLink: function copyNoBrandLink() {
      var that = this,
        link = this.shareLink;
      if (this.type == 1) {
        link = updateUrlParam(link, "channel", "noBrand");
      } else {
        link = updateUrlParam(link, "scenicFrom", "noBrand");
      }
      link = updateUrlParam(link, "isShop", "1"); //带上店铺模式的标识

      var clearParamList = ["enterMode", "source", "tagId", "tag_id", "tagName", "tag_name", "tag2Id", "tag2_id", "tag2Name", "tag2_name", "itemId"]; //需要清除的参数
      for (var _i = 0, _clearParamList = clearParamList; _i < _clearParamList.length; _i++) {
        var param = _clearParamList[_i];
        link = updateUrlParam(link, param, "");
      }
      while (/&$/.test(link)) {
        link = link.replace(/&$/, "");
      }
      while (/&&/.test(link)) {
        link = link.replace(/&&/g, "&");
      }
      if (checkCopyUsable(10)) {
        copy(link).success(function () {
          that.toast("已复制无品牌链接");
        }).fail(function () {
          that.toast("链接复制失败，请重试！");
        });
      } else {
        that.toast("复制失败，请更新到ios10或以上版本！");
      }
    },
    //显示无品牌二维码弹框
    showQRcode: function showQRcode() {
      componentCenter.nobrandQrcode && componentCenter.nobrandQrcode.showQrcode(this.shareLink);
    },
    // 无品牌海报
    getNoPoster: function getNoPoster(_this) {
      //商详页生成海报
      if (this.posterNoImg) {
        if (this.isAPP) {
          showProductPoster();
        } else {
          componentCenter.multiplePosters.showBox(this.posterNoImg);
        }
        return true;
      }
      if (typeof this.shareLink != "string") return false;
      var that = this,
        link = this.shareLink;
      if (this.type == 1) {
        link = updateUrlParam(link, "channel", "noBrand");
      } else {
        link = updateUrlParam(link, "scenicFrom", "noBrand");
      }
      link = updateUrlParam(link, "isShop", "1"); //带上店铺模式的标识

      var clearParamList = ["enterMode", "source", "tagId", "tag_id", "tagName", "tag_name", "tag2Id", "tag2_id", "tag2Name", "tag2_name", "itemId"]; //需要清除的参数
      for (var _i2 = 0, _clearParamList2 = clearParamList; _i2 < _clearParamList2.length; _i2++) {
        var param = _clearParamList2[_i2];
        link = updateUrlParam(link, param, "");
      }
      while (/&$/.test(link)) {
        link = link.replace(/&$/, "");
      }
      while (/&&/.test(link)) {
        link = link.replace(/&&/g, "&");
      }
      databus({
        url: "/apiv2/marketing/getPoster",
        type: "get",
        data: {
          noLogoStore: 1,
          type: 1,
          storeId: _this.couponDetail.isStore && _this.couponDetail.storeData && _this.couponDetail.storeData.storeId || "",
          productId: that.goodId,
          url: link || "",
          rateplan: getUrlParams("rateplan") || "",
          //价格计划加密串
          saleNum: _this.couponDetail.labelType == 1 ? _this.couponDetail.saleNum : 0,
          //销量
          activityEndTime: _this.activityId ? _this.couponDetail.queueEndTime : null //活动结束时间戳
        },

        success: function success(res) {
          if (res.code == 1000 && res.bcode == 100) {
            res.content = res.content || {};
            if (res.content.posterImg && res.content.posterImg.length) {
              that.posterNoImg = res.content.posterImg;
            } else {
              that.posterNoImg = "";
            }
          } else {
            that.toast(res.message || "海报图生成失败，请刷新页面重试");
          }
        },
        error: function error() {
          that.toast("网络有误，请重试");
        },
        beforeSend: function beforeSend() {
          that.showLoading();
        },
        complete: function complete() {
          hideLoading();
          if (that.posterNoImg) {
            if (that.isAPP) {
              showProductPoster();
            } else {
              componentCenter.multiplePosters.showBox(that.posterNoImg);
            }
          }
        }
      });

      //跳转到app原生推广界面
      function showProductPoster() {
        var urlArr = []; //存放海报图和相册图url列表
        urlArr = urlArr.concat(that.posterNoImg);
        for (var i = 0, count = 0; i < _this.albumUrl.length; i++) {
          if (_this.albumUrl[i]) {
            urlArr.push(_this.albumUrl[i]);
            count++;
            if (count >= 10) {
              break; //最多10张相册图
            }
          }
        }

        ykzApp.ready(function () {
          ykzApp.showProductPoster({
            posterUrl: urlArr,
            posterImgCount: that.posterNoImg && that.posterNoImg.length || 0,
            copyText: _this.couponDetail.goodsAlias || _this.couponDetail.goodsName,
            miniShareTitle: _this.couponDetail.miniShareTitle,
            miniShareImgUrl: _this.couponDetail.miniShareImgUrl || "",
            anchorData: {
              item_id: that.goodId,
              type: "product",
              activity_id: _this.activityId,
              source: "product"
            }
          });
        });
      }
    },
    //生成海报图，_this：父组件所带的数据
    getPoster: function getPoster(_this) {
      //酒景页生成海报
      if (this.type == 2) {
        _this.createGoodsPoster();
        return true;
      }

      //商详页生成海报
      if (this.posterImg) {
        if (this.isAPP) {
          showProductPoster();
        } else {
          componentCenter.multiplePosters.showBox(this.posterImg);
        }
        return true;
      }
      var that = this;
      databus({
        url: "/apiv2/marketing/getPoster",
        type: "get",
        data: {
          type: 1,
          storeId: _this.couponDetail.isStore && _this.couponDetail.storeData && _this.couponDetail.storeData.storeId || "",
          productId: that.goodId,
          url: that.posterLink || "",
          rateplan: getUrlParams("rateplan") || "",
          //价格计划加密串
          saleNum: _this.couponDetail.labelType == 1 ? _this.couponDetail.saleNum : 0,
          //销量
          activityEndTime: _this.activityId ? _this.couponDetail.queueEndTime : null //活动结束时间戳
        },

        success: function success(res) {
          if (res.code == 1000 && res.bcode == 100) {
            res.content = res.content || {};
            if (res.content.posterImg && res.content.posterImg.length) {
              that.posterImg = res.content.posterImg;
            } else {
              that.posterImg = "";
            }
          } else {
            that.toast(res.message || "海报图生成失败，请刷新页面重试");
          }
        },
        error: function error() {
          that.toast("网络有误，请重试");
        },
        beforeSend: function beforeSend() {
          that.showLoading();
        },
        complete: function complete() {
          hideLoading();
          if (that.posterImg) {
            if (that.isAPP) {
              showProductPoster();
            } else {
              componentCenter.multiplePosters.showBox(that.posterImg);
            }
          }
        }
      });

      //跳转到app原生推广界面
      function showProductPoster() {
        var urlArr = []; //存放海报图和相册图url列表
        urlArr = urlArr.concat(that.posterImg);
        for (var i = 0, count = 0; i < _this.albumUrl.length; i++) {
          if (_this.albumUrl[i]) {
            urlArr.push(_this.albumUrl[i]);
            count++;
            if (count >= 10) {
              break; //最多10张相册图
            }
          }
        }

        ykzApp.ready(function () {
          ykzApp.showProductPoster({
            posterUrl: urlArr,
            posterImgCount: that.posterImg && that.posterImg.length || 0,
            copyText: _this.couponDetail.goodsAlias || _this.couponDetail.goodsName,
            miniShareTitle: _this.couponDetail.miniShareTitle,
            miniShareImgUrl: _this.couponDetail.miniShareImgUrl || "",
            anchorData: {
              item_id: that.goodId,
              type: "product",
              activity_id: _this.activityId,
              source: "product"
            }
          });
        });
      }
    },
    //获取短链接
    getShortUrl: function getShortUrl() {
      if (this.shareLinkBoxStatus > 1) {
        this.showShareLink = true;
        return true;
      }
      this.showShareLink = true;
      this.shareLinkBoxStatus = 1;
      this.$nextTick(function () {
        $(".share-link .transition-content").css("height", $(".share-link .status-one").innerHeight());
      });
      var that = this;
      databus({
        url: "appapi/promotionmall/getShortUrl",
        type: "get",
        data: {
          url: encodeURIComponent(that.shareLink)
        },
        success: function success(res) {
          if (res.code == 1000) {
            that.shortUrl = res.content.shortUrl || "";
            if (!checkCopyUsable(10)) {
              that.shareLinkBoxStatus = 2;
              that.$nextTick(function () {
                $(".share-link .transition-content").css("height", $(".share-link .status-two").innerHeight());
              });
            } else {
              that.shareLinkBoxStatus = 3;
              that.$nextTick(function () {
                $(".share-link .transition-content").css("height", $(".share-link .status-two.status-three").innerHeight());
              });
            }
            $(".share-link .status-two .txt-p").bind("touchstart", function () {
              that.selectText(this);
            });
          } else {
            that.hideBox(2);
            that.shareLinkBoxStatus = 0;
            that.toast(res.message || "生成链接失败，请重试！");
          }
        },
        error: function error() {
          that.hideBox(2);
          that.shareLinkBoxStatus = 0;
          that.toast("网络有误，请重试");
        },
        beforeSend: function beforeSend() {
          that.showLoading();
        },
        complete: function complete() {
          hideLoading();
        }
      });
    },
    //复制短链接
    copyShortUrl: function copyShortUrl() {
      var that = this;
      copy(this.shareTxt + " " + this.shortUrl).success(function () {
        that.shareLinkBoxStatus = 4;
        that.toast("文案复制成功！");
      }).fail(function () {
        that.toast("文案复制失败，请重试！");
      });
    },
    selectText: function selectText(element) {
      var range, selection;
      if (document.body.createTextRange) {
        range = document.body.createTextRange();
        range.moveToElementText(element);
        range.select();
      } else if (window.getSelection) {
        selection = window.getSelection();
        range = document.createRange();
        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);
      } else {
        //浏览器内核不支持
      }
    }
  }
};